module.exports = __webpack_public_path__ + "img/scanqrcode.f22c2c4.png";